const open = (chatBot) => {
  chatBot.toggleOpen && chatBot.toggleOpen();

  window.requestAnimationFrame(() => {
    console.log(`chatBot.shadowRoot.querySelector('cb-user-input-mm')?.shadowRoot.querySelector('.cb-user-input')?.shadowRoot.querySelector('.textarea__control')`, chatBot.shadowRoot.querySelector('cb-user-input-mm')?.shadowRoot.querySelector('.cb-user-input')?.shadowRoot.querySelector('.textarea__control'));
    chatBot.shadowRoot.querySelector('cb-user-input-mm')?.shadowRoot.querySelector('.cb-user-input')?.shadowRoot.querySelector('.textarea__control')?.focus();
  });
}

class ChatIndicator extends HTMLElement {
  constructor() {
    super();

    this.siteHeader = document.querySelector("section-header");
    this.querySelector("button").classList.toggle(
      "chat-indicator__button--active",
      this.hasAttribute("enable-indicator"),
    );

    this.addEventListener("click", () => {
      const chatBot = document.querySelector("enegelai-bot");

      if (!chatBot) return;

      open(chatBot);
      if (this.siteHeader) {
        this.siteHeader.closeMobileNav();
      }
    });

    const url = new URL(window.location);

    let attempts = 0

    if (url.searchParams.has('chat')) {
      const interval = setInterval(() => {
        if (attempts > 20) {
          clearInterval(interval);
          return;
        };

        const chatBot = document.querySelector("enegelai-bot");

        if (!chatBot) {
          attempts++;
          return;
        };

        clearInterval(interval);
        open(chatBot);
      }, 500);
    }
  }
}

if (!customElements.get("chat-indicator")) {
  customElements.define("chat-indicator", ChatIndicator);
}
